var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement } from 'react';
import { Flex } from '@tpr/core';
import styles from './separator.module.scss';
export var SeparatorX = function (_a) {
    var children = _a.children;
    var clones = Children.map(children, function (_a) {
        var props = _a.props, child = __rest(_a, ["props"]);
        var hint = props.hint, _b = props.cfg, cfg = _b === void 0 ? {} : _b, allProps = __rest(props, ["hint", "cfg"]);
        return cloneElement(child, __assign({ cfg: Object.assign(cfg, { mr: 8 }), hint: hint, className: styles.maxWidth }, allProps));
    });
    return React.createElement(Flex, null, clones);
};
export var SeparatorY = function (_a) {
    var children = _a.children;
    var clones = Children.map(children, function (child) {
        return cloneElement(child, { cfg: { mt: 1, mb: 3 } });
    });
    return React.createElement(Flex, { cfg: { flexDirection: 'column' } }, clones);
};
//# sourceMappingURL=separator.js.map